import fetchClient, { ApiResponse } from '@/api/api-client'

import {
  CreatePkgCasePayload,
  CustomerPkgInRange,
  CustomerPkgsParams,
  ExistingPkgMatch,
  PkgCase,
  PkgCaseCounts,
  PkgCaseListParams,
  RespondPkgCasePayload,
} from './types'

export async function getPkgCases(params: PkgCaseListParams = {}) {
  const res = await fetchClient.get<ApiResponse<PkgCase[]>>('/pkg-cases', { params })
  return res.data.data ?? []
}

export async function getPkgCase(id: string) {
  const res = await fetchClient.get<ApiResponse<PkgCase>>(`/pkg-cases/${id}`)
  if (!res.data.data) throw new Error('Package case not found')
  return res.data.data
}

export async function getPkgCaseCounts(warehouse?: PkgCaseListParams['warehouse']) {
  const res = await fetchClient.get<ApiResponse<PkgCaseCounts>>('/pkg-cases/counts', {
    params: warehouse ? { warehouse } : undefined,
  })
  return (
    res.data.data ?? {
      awaitingWarehouse: 0,
      needsFollowUp: 0,
      myNeedsFollowUp: 0,
      myUnseenResponses: 0,
    }
  )
}

export async function getCustomerPkgsInRange(params: CustomerPkgsParams) {
  const res = await fetchClient.get<ApiResponse<CustomerPkgInRange[]>>('/pkg-cases/customer-pkgs', { params })
  return res.data.data ?? []
}

export async function getExistingPkgs(trackingNumber: string) {
  const res = await fetchClient.get<ApiResponse<ExistingPkgMatch[]>>('/pkg-cases/existing-pkgs', {
    params: { trackingNumber },
  })
  return res.data.data ?? []
}

export async function createPkgCase(payload: CreatePkgCasePayload) {
  const res = await fetchClient.post<ApiResponse<PkgCase>>('/pkg-cases', payload)
  if (!res.data.data) throw new Error('Failed to create package case')
  return res.data.data
}

export async function respondToPkgCase(id: string, payload: RespondPkgCasePayload) {
  const res = await fetchClient.post<ApiResponse<PkgCase>>(`/pkg-cases/${id}/respond`, payload)
  if (!res.data.data) throw new Error('Failed to respond to package case')
  return res.data.data
}

export async function creditPkgCase(id: string) {
  const res = await fetchClient.post<ApiResponse<PkgCase>>(`/pkg-cases/${id}/credit`)
  if (!res.data.data) throw new Error('Failed to move package case to credit')
  return res.data.data
}

export async function markPkgCaseSeen(id: string) {
  const res = await fetchClient.post<ApiResponse<PkgCase>>(`/pkg-cases/${id}/seen`)
  if (!res.data.data) throw new Error('Failed to update package case')
  return res.data.data
}

export async function closePkgCase(id: string) {
  const res = await fetchClient.post<ApiResponse<PkgCase>>(`/pkg-cases/${id}/close`)
  if (!res.data.data) throw new Error('Failed to close package case')
  return res.data.data
}

export async function resubmitPkgCase(id: string, note: string) {
  const res = await fetchClient.post<ApiResponse<PkgCase>>(`/pkg-cases/${id}/resubmit`, { note })
  if (!res.data.data) throw new Error('Failed to send package case back')
  return res.data.data
}
